<template>
  <div class="testSolve">
    <div class="background"></div>
    <div class="wrap">
      <h1>{{ testName }}</h1>
      <!----------------------------------------------------------------------------Questions 1 to 5 - T/F-------------------------------------------------------------------------------------->
      <div class="tasksSection">
        <h2 class="sectionOne">{{ t("sectionOne") }}</h2>
        <div class="formsSectionOne">
          <form class="formsTest" id="answerForm" @submit.prevent="showResults">
            <div class="formsTest" v-for="(testItem, index) in testItems" :key="index">
              <div class="taskComponent" id="taskSection1" v-if="testItem.type == 'True/False'">
                <div class="taskOnlyS1">
                  <h4>{{ t("taskTitle") }} {{ index + 1 }}: {{ t("choose") }}</h4>
                  <p>{{ testItem.task }}</p>
                  <div class="true-false">
                    <RadioGroup
                      v-model="studentAnswers[index]"
                      :options="answerOptions"
                      vertical
                      :name="String(index)"
                    />
                  </div>
                </div>
                <div class="imagesInQuestion">
                  <img class="inlineImages" :src="getImage(testItem.pictureLink)">
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-----------------------------------------------------------------------Questions 5 to 10 - Calculations--------------------------------------------------------------------------------->
        <h2 class="section-two">{{ t("sectionTwo") }}</h2>
        <div class="formsSectionTwo">
          <form class="formsTest" id="answerForm" @submit.prevent="showResults">
            <div class="formsTest" v-for="(testItem, index) in testItems" :key="index">
              <div class="taskComponent" id="taskSection2" v-if="testItem.type == 'Calculation'">
                <div class="taskOnlyS2">
                  <h4>{{ t("taskTitle") }} {{ index + 1 }}: {{ t("calculate") }}</h4>
                  <p>{{ testItem.task }}</p>
                  <BaseInput
                    class="answerBox"
                    :placeholder="t('type')"
                    v-model="studentAnswers[index]"
                    :label="t('answer')"
                    type="text"
                  />
                </div>

                <div class="imagesInQuestion">
                  <img class="inlineImages" :src="getImage(testItem.pictureLink)">
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!--------------------------------------------------------------------------------Press Finish------------------------------------------------------------------------------------------------->
      <div class="finishTest">
        <button
          form="answerForm"
          type="submit"
          @click="getResult"
          :disabled="!this.enableButton()"
          :class="{
            disabledButton: !this.enableButton(),
          }"
        >{{ t("finish") }}</button>
        <p class="validationText" v-if="!this.enableButton()">{{ t("validation") }}</p>
      </div>
    </div>
  </div>
</template>

 
<script>
import RadioGroup from "@/components/RadioGroup";
import BaseInput from "@/components/BaseInput.vue";
import { useI18n } from "vue-i18n";
import i18n from "@/i18n";

export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },
  name: "testSolve",
  components: {
    BaseInput,
    RadioGroup
  },
  data() {
    return {
      studentAnswers: [],
      language: i18n.global.locale.value,
      isCompleted: false,
      answerOptions: [
        { label: this.t("true"), value: this.t("true") },
        { label: this.t("false"), value: this.t("false") }
      ],
      unwantedCharacters: []
    };
  },

  computed: {
    testName() {
      return this.$store.state.testName;
    },
    testChoice() {
      return this.$store.state.testChoice;
    },
    testItems() {
      return this.$store.state.testItems;
    }
  },
  created() {
    this.$store.dispatch("fetchChosenTest");
  },
  methods: {
    enableButton() {
      let checkResult = [];
      this.studentAnswers.forEach(element => {
        if (
          !/[!"£$%^&*~}{@><?/]/.test(element) &&
          element &&
          element.length < 30
        ) {
          checkResult.push(true);
        } else {
          checkResult.push(false);
        }
      });

      if (checkResult.every(a => a == true) && checkResult.length == 10) {
        this.isCompleted = true;
      } else {
        this.isCompleted = false;
      }
      return this.isCompleted;
    },

    getResult() {
      this.$store.commit("SET_STUDENT_ANSWERS", this.studentAnswers);
    },

    async showResults() {
      await this.$store.dispatch("postAnswers");
      await this.$store.dispatch("postResult");
      await this.$router.replace({ name: "result" });
    },

    getImage(image) {
      return `https://phoenix-engineering-images.ams3.digitaloceanspaces.com/${image}`;
    }
  }
};
</script>

<i18n>
{
  "en-GB": {
    "taskTitle":"Task",
    "sectionOne": "Section 1 - Is the statement true or false?",
    "choose":"Choose true or false.",
    "true": "True",
    "false":"False",

    "sectionTwo": "Section 2 - Open-ended tasks",
    "calculate":"Write your answer in the answerbox.",
    "answer":"Answer:",
    "type":"Type your answer here",

    "validation":"Please make sure you have answered all tasks, wrote a NUMBER OR A WORD where needed",
    "finish":"Finish test"
  },
  "nl-NL": {
    "taskTitle":"Taak",
    "sectionOne": "Sectie 1 - Is de verklaring goed of fout?",
    "choose":"Kies goed of fout.",
    "true": "Goed",
    "false":"Fout",

    "sectionTwo": "Sectie 2 - Taken met een open einde",
    "calculate":"Typ je antwoord in de antwoordbox",
    "answer":"Antwoord:",
    "type":"Typ hier uw antwoord.",
    
    "validation":"Zorg er alstublieft voor dat alle opdrachten zijn beantwoord, schrijf een GETAL of een WOORD waar nodig",
    
    "finish":"Afwerkingstest"
  }
}
</i18n>

<style scoped>
.testSolve {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;
}

.background {
  background-image: url("https://phoenix-engineering.be/wp-content/uploads/2019/07/shutterstock_1113165392.png");
  background-size: cover;
  background-position: unset;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  filter: blur(3px);
  -webkit-filter: blur(3px);
  z-index: -1;
}

.wrap {
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
  background-color: rgb(41, 41, 42);
  width: 85%;
  box-shadow: 0 0px 5px 0px rgb(114, 108, 109);
  border: 30px solid rgb(41, 41, 42);
}

h1 {
  text-transform: uppercase;
  font-size: 40px;

  margin: 30px;
  color: white;
}

h2 {
  font-size: 27px;
}

.tasksSection {
  display: center;
  text-align: left;
  background-color: rgb(87, 87, 87);
}

.tasksSection h2 {
  border-top: 30px solid rgb(41, 41, 42);
  background-color: rgb(87, 87, 87);
  text-align: center;
  margin: 0px;
  text-transform: uppercase;

  color: white;
  padding: 30px;
}

/* ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */

.taskComponent {
  display: flex;
  border: solid 30px rgb(87, 87, 87);
  background-color: rgb(163, 163, 163);
  margin-bottom: 0px;
  margin-top: -30px;
}

.taskOnlyS1 {
  box-sizing: border-box;
  width: 70%;
  margin-left: 30px;
  margin-right: 20px;
  margin-top: 20px;
  font-size: 18px;
  position: relative;
}

.taskOnlyS1 h4 {
  margin-top: 0;
  margin-bottom: 5px;
}

.imagesInQuestion {
  align-items: center;
  display: flex;
  justify-content: center;
}

.inlineImages {
  border: solid rgb(163, 163, 163) 1vw;
  width: 420px;
  height: 280px;
}

/*-----------------------------------------------------------------------Questions 1 to 5 - true or false-----------------------------------------------------------------------------*/

.true-false {
  margin-bottom: 20px;
  font-weight: bold;
}

/*-----------------------------------------------------------------------Questions 5 to 10 - Calculation--------------------------------------------------------------------------------*/

.answerBox {
  margin-top: auto;
  font-weight: bold;
  margin-bottom: 20px;
}
p {
  font-weight: normal;
  margin-bottom: 5px;
}

.taskOnlyS2 {
  display: flex;
  flex-direction: column;
  width: 70%;
  margin-left: 30px;
  margin-right: 20px;
  margin-top: 20px;
  font-size: 18px;
}

.taskOnlyS2 h4 {
  margin-top: 0;
  margin-bottom: 5px;
}

/*---------------------------------------------------------------------------------Finish Exam--------------------------------------------------------------------------------------------------*/

.finishTest {
  border-top: 30px solid rgb(41, 41, 42);
  background-color: rgb(41, 41, 42);
}

button {
  font-family: "Raleway", sans-serif;
  letter-spacing: 1.5px;

  padding: 25px 40px;
  background-color: rgb(165, 0, 41);
  border-style: none;
  color: rgb(255, 255, 255);

  font-size: 20px;
  cursor: pointer;
}

button:hover {
  transform: scale(1.03);
}

.disabledButton {
  opacity: 0.5;
  cursor: not-allowed;
}

.validationText {
  margin-top: 20px;

  color: white;
  letter-spacing: 1.2px;

  font-size: 15px;

  padding-left: 15px;
  padding-right: 15px;
}

/*---------------------------------------------------------------------------------Media--------------------------------------------------------------------------------------------------*/

@media screen and (max-width: 1300px) {
  h2 {
    padding: 15px;
  }
  .true-false {
    font-size: 17px;
  }
  .answerBox {
    font-size: 17px;
  }
  .imagesInQuestion {
    text-align: center;
  }
  p {
    margin-top: 5px;
    font-size: 17px;
  }
  .inlineImages {
    width: 345px;
    height: 230px;
  }
}

@media screen and (max-width: 1030px) {
  h1 {
    font-size: 30px;
    margin: 15px;
  }
  h2 {
    padding: 10px;
    font-size: 23px;
  }
  h4 {
    font-size: 16px;
  }
  .true-false {
    font-size: 14px;
  }
  .answerBox {
    font-size: 14px;
  }
  .imagesInQuestion {
    text-align: center;
  }
  p {
    margin-top: 5px;
    font-size: 16px;
  }
  .inlineImages {
    width: 300px;
    height: 200px;
  }
}

@media screen and (max-width: 920px) {
  .wrap {
    border: 20px solid rgb(41, 41, 42);
  }

  .tasksSection h2 {
    border-top: 20px solid rgb(41, 41, 42);
  }

  h2 {
    padding: 15px;
  }
  .taskComponent {
    flex-direction: column;
  }

  .taskOnlyS1 {
    width: 90%;
  }
  .taskOnlyS2 {
    width: 90%;
  }

  .imagesInQuestion {
    text-align: center;
  }

  p {
    margin-top: 5px;
    margin-bottom: 10px;
    font-size: 17px;
  }
  .inlineImages {
    width: 375px;
    height: 250px;
    margin-bottom: 20px;
  }
  .answerBox {
    margin-left: 0px;
  }
  .finishTest {
    border-top: 20px solid rgb(41, 41, 42);
  }
  .validationText {
    font-size: 14px;
  }
}

@media screen and (max-width: 600px) {
  .wrap {
    margin: 0px;
    width: 100%;
    border-width: 0px;
  }
  h1 {
    margin-top: 30px;
  }

  .taskComponent {
    border: solid 15px rgb(87, 87, 87);

    margin-top: -15px;
  }

  .taskOnlyS1 {
    width: 85%;
  }
  .taskOnlyS2 {
    width: 85%;
  }

  .tasksSection h2 {
    border-top: 15px solid rgb(41, 41, 42);
    font-size: 21px;
    padding: 20px;
  }

  p {
    margin-top: 5px;
    margin-bottom: 10px;
    font-size: 15px;
  }
  .inlineImages {
    width: 75vw;
    height: 50vw;
  }

  .finishTest {
    border-bottom: 20px solid rgb(41, 41, 42);
  }

  button {
    transform: scale(0.8);
  }
  button:hover {
    transform: scale(0.83);
  }

  .validationText {
    font-size: 12px;
  }

  @media screen and (max-width: 370px) {
    .taskOnlyS1 {
      margin-left: 5vw;
    }
    .taskOnlyS2 {
      margin-left: 5vw;
    }
    h4 {
      font-size: 14px;
    }
    p {
      font-size: 14px;
    }
  }
}
</style>
